import { useContext, useEffect, useState } from "react";
import { FcGoogle } from "react-icons/fc";
import "../../assets/css/scss/component/authentication/_leftSideSection.scss";
import { isMobileOnly } from 'react-device-detect';
import { googleLogout, useGoogleLogin, hasGrantedAllScopesGoogle } from '@react-oauth/google';
import axios from 'axios';
import { GoogleOauthContext } from "../../common/context";
import { LOGIN_PAGE, SIGN_UP_PAGE } from "../../constant/menuAndProfile";
import { useSelector } from "react-redux";
import { IReduxStateData } from "../../interfaces/redux";

export default function LeftSideSection() {
  const [user, setUser] = useState<any>({});
  const [profile, setProfile] = useState({});
  const globalState = useSelector((state: IReduxStateData) => state);
  const selectedLang = globalState?.selectedLang || "";
  const isGoogleOauthEnable = useContext(GoogleOauthContext);
  const imageName = "/assets/images/" + (isMobileOnly ? `auth-background-mobile-${Math.floor(Math.random() * 3) + 1}.jpg` : `auth-background-${Math.floor(Math.random() * 3) + 1}.jpg`);

  //https://www.googleapis.com/auth/user.gender.read https://www.googleapis.com/auth/userinfo.email 
  const login = useGoogleLogin({
    scope: "https://www.googleapis.com/auth/user.phonenumbers.read https://www.googleapis.com/auth/user.birthday.read",
    onSuccess: (codeResponse: any) => {
      console.log("codeResponse >", codeResponse);
      setUser(codeResponse);
    },
    onError: (error) => {
      console.log('Login Failed:', error)
    }
  });
  useEffect(
    () => {
      if (user?.access_token) {
        axios
          .get(`https://www.googleapis.com/oauth2/v1/userinfo?alt=json`, {
            headers: {
              Authorization: `Bearer ${user.access_token}`,
              Accept: 'application/json'
            }
          })
          .then((res: any) => {
            console.log("ff >", res)
            setProfile(res.data);
            axios
              .get(`https://people.googleapis.com/v1/people/${res.data.id}?personFields=phoneNumbers,genders,birthdays`, {
                headers: {
                  Authorization: `Bearer ${user.access_token}`,
                  Accept: 'application/json'
                }
              })
              .then(final => {
                console.log("final >", final.data)
              })
              .catch((err) => console.log(err));
          })
          .catch((err) => console.log(err));
      }
    },
    [user]
  );

  // log out function to log the user out of google and set the profile array to null
  const logOut = () => {
    googleLogout();
    // setProfile(null);
  };

  return (
    <div className="left-sidebar d-flex flex-column justify-content-between align-items-center" style={{ "backgroundImage": `url(${imageName})`, "backgroundPosition": "center", "backgroundRepeat": "no-repeat", "backgroundSize": "cover", "backgroundBlendMode": "luminosity" }}>
      <div>
        <h2>{LOGIN_PAGE[selectedLang]['leftSideTitle']}</h2>
        <p className="mb-0 mb-md-3">{LOGIN_PAGE[selectedLang]['leftSideSubTitle']}</p>
      </div>
      {isGoogleOauthEnable ?
        <div className="bottom-card d-none d-md-block">
          <h3 className="font-semibold theme-dark-white">{SIGN_UP_PAGE[selectedLang]['signUpWithGoogleGetStarted']}</h3>
          <button
            className="btn btn-fb d-flex align-items-center justify-content-center"
            onClick={() => login()}
          >
            <span>{SIGN_UP_PAGE[selectedLang]['signUpWithGoogle']} <FcGoogle /></span>
          </button>
          {/* <GoogleLogin
            auto_select={false}
            text="signup_with"
            context="signup"
            native_callback={(response) => console.log("jjj >", response)}
            onSuccess={credentialResponse => {
              console.log(credentialResponse);

              const hasAccess = hasGrantedAnyScopeGoogle(
                credentialResponse.credential,
                'user.birthday.read',
                'user.gender.read'
              );
              console.log("hasAccess >", hasAccess)
            }}
            onError={() => {
              console.log('Login Failed');
            }}
            shape="pill"
          />
           */}
        </div>
        : null}
      {/* <div className="bottom-card-signup">
        <h2 className="theme-dark-black">Congratulations!</h2>
        <h4 className="theme-dark-black mt-3">
          Your account will setup after this step
        </h4>
      </div> */}
    </div>
  );
}
